var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "dashboard__grid dashboard-card__no-min dash-library__content-container dash-library__content-container--no-min h-no-padding"
    },
    [
      _vm.contacts
        ? _c(
            "div",
            {
              staticClass:
                "dashboard__grid dash-library__content-container dash-library__content-container--no-min"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered"
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.groups, function(group, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-md-6" },
                        _vm._l(group, function(contact, index) {
                          return _c("Contact", {
                            key: "contact-" + index,
                            attrs: { contact: contact }
                          })
                        }),
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            ]
          )
        : _vm.loaders.contacts == false && _vm.initializers.contacts == true
        ? _c(
            "div",
            {
              staticClass:
                "dashboard__grid dashboard__alert alert alert-warning"
            },
            [
              _c("div", { staticClass: "dashboard__no-data" }, [
                _vm._v("No contact information available")
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }